module.exports = __webpack_public_path__ + "static/short02-ff854666743c8b084d7b50f0970e0dcd.png";